export enum ResultsViewMode {
    RESULTS = 'results',
    GROUPED = 'grouped',
}
